const fileDexLanSize: Record<string, Record<string, any>> = {};
const dexMap: Record<string, string[]> = {};
const dexLinks: string[] = [];
const adDexMap: Record<string, any> = {};

const modules = import.meta.glob("./modules/*.ts", {
  import: "default",
  eager: true,
});

Object.keys(modules).forEach(key => {
  const filename = key.split("/").pop()?.replace(".ts", "");
  if (typeof filename === "string" && !fileDexLanSize[filename]) {
    const module = modules[key] as Record<string, any>;
    if (module && typeof module === "object" && Object.keys(module).length > 0) {
      dexMap[filename] = [];
      dexMap[filename].push(...Object.keys(module));
      dexLinks.push(...Object.keys(module));
      fileDexLanSize[filename] = module;
      Object.keys(module).forEach(key => {
        adDexMap[key] = module[key];
      });
    }
  }
});
if (isDevEnv || isBuildTest) {
  console.table({
    fileDexLanSize,
    adDexMap,
    dexMap,
    dexLinks,
  });
}

export { fileDexLanSize, dexMap, dexLinks, adDexMap };
